import React, { Component } from "react";

import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";

import { setCemetery } from "../../redux/actions";

import { lostowice, oliwa, srebrzysko, cemeteries } from "../../constants";

import "antd/dist/antd.css";

class Menu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showCemeteryList: false,
    };
  }

  render() {
    const getCemetaryName = (cemetery) => {
      switch (cemetery) {
        case "oliwa":
          return oliwa.name;
        case "srebrzysko":
          return srebrzysko.name;
        case "lostowice":
          return lostowice.name;
        default:
          return;
      }
    };

    const cemetaryName = getCemetaryName(this.props.data.name);
    const showCemeteryList = this.state.showCemeteryList && this.props.showMenu;

    return (
      <div>
        <div
          className={`menu-container menu-container--${
            this.props.showMenu ? "show" : "hide"
          }`}>
          <div className='menu'>
            <div className='menu-title'></div>

            <div
              className={`menu-list menu-list-long menu-list-long--${
                showCemeteryList ? "show" : "hide"
              }`}>
              {cemeteries.map((cemetery) => (
                <div
                  key={cemetery.var}
                  onClick={() => {
                    this.props.history.push(`/${cemetery.var}`);
                    this.setState({ showCemeteryList: false });
                  }}
                  className={`menu-item grave cemetery cemetery--${cemetery.var}`}>
                  <div className='menu-item__content'>
                    <span>{cemetery.name}</span>
                    <div className='color' />
                  </div>
                </div>
              ))}
            </div>

            <div
              className={`menu-list menu-list--${
                showCemeteryList ? "hide" : "show"
              }`}>
              <div
                onClick={() => this.props.onMenuToggle()}
                className='menu-item list'>
                <NavLink
                  className='menu-item__content'
                  to={`/${this.props.data.name}/list`}>
                  <span className='icon'></span>
                  <span>
                    GROBY <br /> -{cemetaryName}
                  </span>
                  <div className='color' />
                </NavLink>
              </div>

              <div
                onClick={() => this.setState({ showCemeteryList: true })}
                className='menu-item grave'>
                <div className='menu-item__content'>
                  <span className='icon'></span>
                  <span>
                    WYBIERZ <br /> CMENTARZ
                  </span>
                  <div className='color' />
                </div>
              </div>

              <div
                onClick={() => this.props.onMenuToggle()}
                className='menu-item paths'>
                <NavLink
                  className='menu-item__content'
                  to={`/${this.props.data.name}/paths`}>
                  <span className='icon'></span>
                  <span>
                    ŚCIEŻKI
                    <br /> -{cemetaryName}
                  </span>
                  <div className='color' />
                </NavLink>
              </div>

              <div
                onClick={() => this.props.onMenuToggle()}
                className='menu-item my-paths'>
                <NavLink
                  className='menu-item__content'
                  to={`/${this.props.data.name}/my-paths/${localStorage.getItem(
                    "hash"
                  )}`}>
                  <span className='icon'></span>
                  <span>
                    {" "}
                    MOJA ŚCIEŻKA <br />-{cemetaryName}
                  </span>
                  <div className='color'></div>
                </NavLink>
              </div>

              <div
                onClick={() => this.props.onMenuToggle()}
                className='menu-item about-project'>
                <NavLink className='menu-item__content' to='/about-project'>
                  <span className='icon'></span>
                  <span>O PROJEKCIE</span>
                  <div className='color'></div>
                </NavLink>
              </div>
              <div
                onClick={() => this.props.onMenuToggle()}
                className='menu-item about-app'>
                <NavLink className='menu-item__content' to='/about-app'>
                  <span className='icon'></span>
                  <span>O APLIKACJI</span>
                  <div className='color'></div>
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => (state) => ({
  data: state.Data,
});

export default withRouter(connect(mapStateToProps)(Menu));



// WEBPACK FOOTER //
// ./src/js/components/menu/index.js